/**
 * The store's social profiles.
 *
 * These used to point at `https://instagram.com`, `https://tiktok.com` and
 * `https://facebook.com` — the networks' own homepages, not Rosita Store's
 * profiles. An entry with an empty `url` is not rendered at all, so a profile
 * that does not exist yet leaves no broken link behind.
 */
export interface SocialLink {
  label: string;
  url: string;
}

export const socialLinks: readonly SocialLink[] = [
  { label: 'Instagram', url: 'https://www.instagram.com/rosita_storee/' },
  { label: 'TikTok', url: 'https://www.tiktok.com/@rosita_storee' },
  {
    label: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=100063264426924',
  },
];

export const activeSocialLinks = socialLinks.filter((link) => link.url.trim().length > 0);
